<footer class="footer">
    <div class="footer-content">
        <div class="footer-section about">
            <h2>Our information</h2>
            <p>East Flager ST.</p>
            <p>Miami, Florida</p>
            <p>+1 786 123 1234.</p>
        </div>
        <div class="footer-section links">
            <h2>About Us</h2>
            <ul>
                <li><a href="#">Support Center</a></li>
                <li><a href="#">Customer Support</a></li>
                <li><a href="#">About Us</a></li>
                <li><a href="#">Copy Right</a></li>
            </ul>
        </div>
        <div class="footer-section links">
            <h2>Product</h2>
            <ul>
                <li><a href="#">Watch</a></li>
                <li><a href="#">Rings</a></li>
                <li><a href="#">Chains</a></li>
                <li><a href="#">Accesories</a></li>
            </ul>
        </div>
        <div class="footer-section contact">
            <h2>Social</h2>
            <a href="https://facebook.com" target="_blank"><i class="fab fa-facebook-f"></i></a>
            <a href="https://twitter.com" target="_blank"><i class="fab fa-twitter"></i></a>
            <a href="https://instagram.com" target="_blank"><i class="fab fa-instagram"></i></a>
        </div>
    </div>
    <hr class="footer-bottom-divider" />
    <div class="footer-bottom">
        <p>&copy; Watchzaar. All rights reserved.</p>
    </div>
</footer>
